import React from 'react'
import { Router, Route, IndexRoute, browserHistory } from 'react-router';
import App from './components/App/App';
import Explorer from './components/Explorer/Explorer';
import Address from './components/Address/Address';
import Sequence from './components/Sequence/Sequence';
import Transaction from './components/Transaction/Transaction';
import CirculatingSupply from './components/CirculatingSupply';
import NoMatch from './components/NoMatch';
import LiquidityPool from './components/LiquidityPool/LiquidityPool';
import Stats from './components/Stats/Stats';

const Routes = props => {
  return (
    <Router history={browserHistory}>
      <Route path="/" component={App}>
        <IndexRoute component={Explorer}/>
        <Route path="/address/:id" component={Address}/>
        <Route path="/network_overview" component={Stats}/>
        <Route path="/sequence/:id" component={Sequence}/>
        <Route path="/transaction/:id" component={Transaction}/>
        <Route path="/liquidity_pool/:id" component={LiquidityPool}/>
        <Route path="/circulating-supply" component={CirculatingSupply} />
        <Route path="*" component={NoMatch}/>
      </Route>
    </Router>
  )
}

export default Routes



// WEBPACK FOOTER //
// ./src/routes.js